import { render, staticRenderFns } from "./forgotpwd.vue?vue&type=template&id=51a182d0"
import script from "./forgotpwd.vue?vue&type=script&lang=js"
export * from "./forgotpwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports